import styled from "styled-components";

export const FiltersRow = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: flex-end;
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 160px;
  min-width: 140px;
`;

export const FilterLabel = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

export const FilterSelect = styled.select`
  padding: 7px 10px;
  border: 1.5px solid #e2e8f0;
  border-radius: 9px;
  font-size: 13px;
  color: #1e293b;
  background: #fff;
  outline: none;
  transition: border-color 0.15s;
  &:focus {
    border-color: #3f88a5;
    box-shadow: 0 0 0 3px rgba(63,136,165,0.08);
  }
  &:disabled {
    background: #f8fafc;
    color: #94a3b8;
    cursor: not-allowed;
  }
`;

export const SectionDivider = styled.tr`
  background: #f8fafc;
  td {
    padding: 8px 14px;
    font-size: 12px;
    font-weight: 700;
    color: #3f88a5;
    letter-spacing: 0.2px;
    border-bottom: 1px solid #e2e8f0;
  }
`;

export const InlineInput = styled.input`
  padding: 6px 10px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #1e293b;
  background: #fff;
  outline: none;
  width: 100%;
  min-width: 110px;
  transition: border-color 0.15s;
  &:focus {
    border-color: #3f88a5;
    box-shadow: 0 0 0 3px rgba(63,136,165,0.08);
  }
  &::placeholder {
    color: #cbd5e1;
    font-size: 12px;
  }
`;

export const InlineSelect = styled.select`
  padding: 6px 10px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #1e293b;
  background: #fff;
  outline: none;
  width: 100%;
  min-width: 110px;
  transition: border-color 0.15s;
  &:focus {
    border-color: #3f88a5;
    box-shadow: 0 0 0 3px rgba(63,136,165,0.08);
  }
`;

export const SaveBtn = styled.button`
  padding: 6px 14px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  background: ${({ disabled }) => (disabled ? "#e2e8f0" : "#3f88a5")};
  color: ${({ disabled }) => (disabled ? "#94a3b8" : "#fff")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  &:hover:not(:disabled) {
    background: #2e6d88;
  }
`;

export const QuestionLabel = styled.span`
  font-size: 13px;
  color: #1e293b;
  font-weight: 400;
`;

export const QuestionGroupTitle = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #3f88a5;
`;

// ─── Breached Triggers tab ────────────────────────────────────────────────────
export const BreachWrapper = styled.div``;

export const BreachTableWrapper = styled.div`
  margin-top: 24px;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  overflow-x: auto;
`;

export const BreachTable = styled.table`
  width: 100%;
  min-width: 980px;
  border-collapse: collapse;
  font-size: 13px;
`;

export const BreachThead = styled.thead`
  background: #f8fafc;
`;

export const BreachTh = styled.th`
  padding: 10px 14px;
  text-align: left;
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-bottom: 1.5px solid #e2e8f0;
  white-space: nowrap;
`;

export const BreachTr = styled.tr`
  &:not(:last-child) td {
    border-bottom: 1px solid #f1f5f9;
  }
  &:hover td {
    background: #f8fafc;
  }
`;

export const BreachTd = styled.td`
  padding: 10px 14px;
  color: #1e293b;
  vertical-align: top;
  white-space: nowrap;
`;

export const BreachKpiTd = styled(BreachTd)`
  white-space: normal;
  min-width: 240px;
`;

export const BreachStatusPill = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  background: ${({ $kind }) => ($kind === "ACTIVE" ? "#fee2e2" : "#dcfce7")};
  color: ${({ $kind }) => ($kind === "ACTIVE" ? "#b91c1c" : "#166534")};
`;

export const BreachEmptyState = styled.div`
  padding: 48px 0;
  text-align: center;
  color: #94a3b8;
  font-size: 14px;
`;

export const BreachEmptyCell = styled.span`
  color: #cbd5e1;
  font-size: 13px;
`;
